<!--Header-->
<app-header *ngIf="isDisplayed"></app-header>

<!--Main Content-->
<main>
    <router-outlet (activate)="onActivate()"></router-outlet>
</main>

<!--Footer-->
<app-footer *ngIf="isDisplayed"></app-footer>

<app-back-to-top-button></app-back-to-top-button>
<simple-notifications></simple-notifications>
